// Copyright (c) 2016 Deere & Company

import PipSearchContainer from '../../pip/pip-search/state-connector';

export default {
    component: PipSearchContainer,
    name: 'PIP_SEARCH',
    path: 'search'
};



// WEBPACK FOOTER //
// ./src/routes/pips/pip-search.js